import { request, errorText as baseErrorText } from "../api";

// /api/accounting/export/datev/* — the DATEV hand-over for the tax advisor.
export const checkExport = params => request.get("/export/datev/check", params);
export const downloadBundle = params => request.blob("/export/datev/bundle", params);
export const listExports = () => request.get("/export/datev/history");

/** Error text that also reads the JSON body of a failed blob download. */
export const errorText = async (error, fallback) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const body = JSON.parse(await data.text());
      if (body?.errorMessage) return body.errorMessage;
    } catch {
      // not JSON: fall through
    }
  }
  return baseErrorText(error, fallback);
};
